const AgendaRoutes = [
    {
      path: "/agenda",
      name: "Agenda",
      component: () => import("@/pages/agenda/AgendaPage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'read', on: 'Task'
        }
      },
      children: [
        {
          path: ":id",
          name: "AgendaShowTask",
          component: () => import("@/pages/tasks/ShowTaskPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'read', on: 'Task'
            }
          }
        },
      ]
    },
  ]
  
  export default AgendaRoutes